import React, { createContext, useContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ThemeContext = createContext({ theme: 'dark', toggleTheme: () => {} });

// Routes that must always stay dark (public / auth pages)
const ALWAYS_DARK_ROUTES = ['/', '/login', '/register', '/auth/callback', '/simulator'];

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem('patrimony_theme') || 'dark';
  });
  const location = useLocation();

  useEffect(() => {
    const isDarkForced = ALWAYS_DARK_ROUTES.some(r => location.pathname === r || location.pathname.startsWith('/auth/'));
    const root = document.documentElement;
    if (theme === 'light' && !isDarkForced) {
      root.classList.add('light');
    } else {
      root.classList.remove('light');
    }
    localStorage.setItem('patrimony_theme', theme);
  }, [theme, location.pathname]);

  const toggleTheme = () => setTheme(t => t === 'dark' ? 'light' : 'dark');

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
